export const en = {
    toLoginAfterConfirmTitle: `Redirecting to login...`,
    toLoginAfterConfirmDescription: `You can now sign in. Redirecting to the login page...`,
    toLoginAfterResetTitle: `Password reset`,
    toLoginAfterResetDescription: `You can now sign in with your new password. Redirecting to the login page...`,
    toResendConfirmationTitle: `Redirecting to confirmation email options...`,
};
//# sourceMappingURL=en.js.map